export default "__VITE_ASSET__C9f6NS$M__"